import { siteCategories } from "@/mocks/manhwaData";

export default function Footer() {
  return (
    <footer className="bg-accent-100 py-12 md:py-14">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl text-primary-700">韩漫导航</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
              漫画韩漫网址导航，聚合热门韩漫站点入口、题材分类与最新发布页，一个页面收齐你想看的韩漫地址。收藏本站，随时找到漫画韩漫网址大全，无需反复搜索直接进入阅读页，追更更方便。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">快速导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-700">
              <li>
                <a href="#hot" className="transition-colors hover:text-primary-600">热门推荐</a>
              </li>
              <li>
                <a href="#categories" className="transition-colors hover:text-primary-600">站点分类</a>
              </li>
              <li>
                <a href="#latest" className="transition-colors hover:text-primary-600">最新发布</a>
              </li>
              <li>
                <a href="#guide" className="transition-colors hover:text-primary-600">追更指南</a>
              </li>
              <li>
                <a href="#faq" className="transition-colors hover:text-primary-600">常见问题</a>
              </li>
              <li>
                <a href="#submit" className="transition-colors hover:text-primary-600">提交收录</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">热门分类</h4>
            <ul className="mt-4 grid grid-cols-2 gap-2.5 text-sm text-foreground-700">
              {siteCategories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <a href="#categories" className="transition-colors hover:text-primary-600">
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-primary-200/50 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">© 2026 漫画韩漫网址导航 · 聚合韩漫站点入口，收藏本站随时追更</p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <span className="flex items-center gap-1">
              <i className="ri-shield-check-line text-secondary-700"></i>
              入口持续更新
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-star-line text-accent-700"></i>
              一键收藏
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}